var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cash_svg__a)",
    d: "M5.536 6.577a.755.755 0 1 1 0-1.51h9.959a.962.962 0 0 0 0-1.924H5.536c-1.48 0-2.679 1.199-2.679 2.678v3.817c0 .614 0 5.069.045 5.401.043.323.14.686.398 1.005l.12.134.135.12c.32.259.682.356 1.005.4.33.044.732.043 1.144.043h8.593c.412 0 .814 0 1.144-.044.322-.043.685-.14 1.005-.398l.134-.12c.349-.35.47-.771.519-1.14.044-.33.044-.732.044-1.144v-1.137h-3.022a1.098 1.098 0 1 1 0-2.198h3.022V9.423c0-.412 0-.814-.044-1.144-.05-.369-.17-.79-.52-1.14-.349-.348-.77-.469-1.138-.518-.34-.046-4.41-.044-4.41-.044H5.535Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cash_svg__a",
    x1: 5.054,
    x2: 17.168,
    y1: 15.423,
    y2: 3.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6E6FC"
  })))));
};
export default SvgCash;